var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAltu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98804 68.0632H15.5052V54.3427H28.9367V40.5285H42.5781V26.9692H56.129V13.5015H76.2473V20.3725H62.8725V33.892H49.3059V47.604H35.7682V61.2427H22.1763V74.9968H1.98804V68.0632Z",
    fill: "#009FDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAltu);
export default __webpack_public_path__ + "static/media/ic_altu.a2cb89d3f51dab4437590387a56604a6.svg";
export { ForwardRef as ReactComponent };